module.exports = global["$"] = require("-!./jquery.js");


//////////////////
// WEBPACK FOOTER
// /var/www/umem/~/expose-loader?$!/var/www/umem/~/jquery/dist/jquery.js
// module id = 2
// module chunks = 0